import React from 'react';
import { EysHero } from '../components/eys/EysHero';
import { EysStory } from '../components/eys/EysStory';
import { EysProduct } from '../components/eys/EysProduct';
import { EysProductThree } from '../components/eys/EysProductThree';
import { EysMadeInUsa } from '../components/eys/EysMadeInUsa';
export function ExtendYourStepPage() {
  return <>
      <EysHero data-id="element-336" />
      <EysStory data-id="element-337" />
      <EysProduct data-id="element-338" />
      <EysProductThree data-id="element-339" />
      <EysMadeInUsa data-id="element-340" />
    </>;
}